import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=b442c2e2&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "./TopNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgMenuIcon: require('D:/Projetos/frontend/components/svg/MenuIcon.vue').default,SvgMobileMenuIcon: require('D:/Projetos/frontend/components/svg/MobileMenuIcon.vue').default,ModalAlterarSenha: require('D:/Projetos/frontend/components/modalAlterarSenha.vue').default})
